/**
 * Determine whether company users exist
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasCompanyUsers = state => state.users.length > 0

/**
 * Return a boolean to determine if user has inbound company invites
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasInboundInvitations = state => state.inbound_invitations.data.length > 0

/**
 * Return whether or not the outbound invitation list is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasOutboundInvitations = state => state.outbound_invitations.data.length > 0

export default {
    hasCompanyUsers,
    hasInboundInvitations,
    hasOutboundInvitations
}



// WEBPACK FOOTER //
// ./src/state/modules/company/getters.js